import React, {useState} from 'react';
import styles from "./CustomTextField.module.scss";
import {InputAdornment, TextField as NoFormikTextField} from '@material-ui/core';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import {ReactComponent as CrossIcon} from 'assets/img/crossIcon.svg';
import {promiseWait} from 'data/utils/shortcuts';
import FormErrorDisplay from '../formErrorDisplay/FormErrorDisplay';
import classNames from "classnames";

interface ICustomTextFieldProps {
  label: string;
  value: string | number;
  disabled: boolean;
  readOnly?: boolean;
  hideWhenNoValue?: boolean;
  noBorder?: boolean;
  className?: string;
  loading?: boolean;
  placeholder?: string;
  name?: any;
  onChange?: any;
  error?: string;
  InputProps?: any;
  required?: boolean;
  field?: any;
  form?: any;
}

const putElementIntoElement = (element, parentSelector, intoElementSelector) => {
  return promiseWait(500)
    .then(() => {
      try {
        if (element) {
          const parent = element.closest(parentSelector).querySelector(intoElementSelector);
          if (parent && typeof parent.append === 'function') {
            parent.append(element);
            return true;
          }
        }
      } catch (e) {
      }
      return false;
    })
};

const CustomTextField = ({loading, hideWhenNoValue, noBorder ,error, field, form, ...props}: ICustomTextFieldProps) => {
    const [textInput, setTextInput] = useState(null);
    if (hideWhenNoValue && !props.value) {
      return null;
    } else if (loading) {
      return <SkeletonPlaceHolder
        className={styles.loadingField}>
        {props.label}
      </SkeletonPlaceHolder>;
    } else {
      return <>
        <NoFormikTextField
          inputRef={(input) => setTextInput(input)}
          variant="outlined"
          fullWidth
          readOnly
          placeholder={props.placeholder}
          inputProps={{
            readOnly: props.readOnly,
          }}
          {...props}
          className={classNames({
            [styles.TextField]: true,
            [styles.readOnly]: props.readOnly,
            [styles.noBorder]: noBorder,
            [props.className]: !!props.className,
            [styles.fieldError]: !!error,
          })}
          InputProps={
            {
              endAdornment: (
                <InputAdornment position='end'>
                  <CrossIcon
                    className={classNames({
                      [styles.clearTextIcon]: true,
                      [styles.hidden]: (props.readOnly || !props.value),
                    })}
                    onClick={async (e) => {
                      if (props.onChange && props.name) {
                        const a = await props.onChange({
                          target: {
                            name: props.name,
                            value: '',
                          },
                        });
                        if (textInput) {
                          textInput.focus();
                        }
                      }
                    }}/>
                </InputAdornment>
              ),
              ...props.InputProps,
            }}
        />
        <FormErrorDisplay className={styles.errorDisplay} error={error}/>
      </>;
    }
  }
;
CustomTextField.defaultProps = {
  label: "",
  value: "",
  disabled: false,
  readOnly: false,
  hideWhenNoValue: false,
  noBorder: false,
  className: '',
  InputProps: {}
};
export default React.memo(CustomTextField);
